// Profile.js
import React, { useContext, useMemo } from 'react';
import styles from './Dashboard.module.css';
import { Outlet } from 'react-router-dom';
import Topbar from '../../Components/Topbar/Topbar';
import AdminContext from '../../Context/adminContext';
import GuestContext from '../../Context/guestContext';

export const TopbarData = [
  {
    title: 'Personal',
    link: '/dashboard/personal',
    disabled: false,
  },
  {
    title: 'Opportunities',
    link: '/dashboard/opportunities',
    disabled: false,
  },
  {
    title: 'Resourcing',
    link: '/dashboard/resourcing',
    disabled: false,
  },
  {
    title: 'Invoicing',
    link: '/dashboard/invoicing',
    disabled: false,
  },
];

function Dashboard() {
  const isAdmin = useContext(AdminContext);

  const filteredTopbarData = useMemo(() => {
    if (isAdmin) return TopbarData;
    return TopbarData.filter(item => item.title === 'Personal');
  }, [isAdmin]);

  return (
    <div className={styles.dashboardContainer}>
      <Topbar TopbarData={filteredTopbarData}  />
      <Outlet />
    </div>
  );
}

export default Dashboard;